const STORAGE_KEY = 'keli.sessionIntent';
export const PREFER_FACTORY_LOGIN_KEY = 'keli.preferFactoryLogin';
const WECHAT_FACTORY_RETURN_KEY = 'keli.wechatFactoryReturn';

export type SessionIntent = 'personal' | 'factory';

export function getSessionIntent(): SessionIntent {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw === 'factory' ? 'factory' : 'personal';
  } catch {
    return 'personal';
  }
}

export function enterFactoryContext(): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, 'factory');
  } catch {
    /* ignore */
  }
}

export function exitFactoryContext(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isFactoryContext(): boolean {
  return getSessionIntent() === 'factory';
}

export function markPreferFactoryLogin(): void {
  try {
    sessionStorage.setItem(PREFER_FACTORY_LOGIN_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function consumePreferFactoryLogin(): boolean {
  try {
    const hit = sessionStorage.getItem(PREFER_FACTORY_LOGIN_KEY) === '1';
    if (hit) sessionStorage.removeItem(PREFER_FACTORY_LOGIN_KEY);
    return hit;
  } catch {
    return false;
  }
}

export function peekPreferFactoryLogin(): boolean {
  try {
    return sessionStorage.getItem(PREFER_FACTORY_LOGIN_KEY) === '1';
  } catch {
    return false;
  }
}

/** Remember that WeChat OAuth/bind started from the factory login gate. */
export function markWechatFactoryReturn(): void {
  try {
    sessionStorage.setItem(WECHAT_FACTORY_RETURN_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function consumeWechatFactoryReturn(): boolean {
  try {
    const hit = sessionStorage.getItem(WECHAT_FACTORY_RETURN_KEY) === '1';
    if (hit) sessionStorage.removeItem(WECHAT_FACTORY_RETURN_KEY);
    return hit;
  } catch {
    return false;
  }
}

export function peekWechatFactoryReturn(): boolean {
  try {
    return sessionStorage.getItem(WECHAT_FACTORY_RETURN_KEY) === '1';
  } catch {
    return false;
  }
}

/** User explicitly left the factory gate for diary login. */
export function clearFactoryLoginReturn(): void {
  consumePreferFactoryLogin();
  consumeWechatFactoryReturn();
}

export function isApprovedFactoryWorker(user: {
  capabilities?: { factoryWorker?: string; factoryManager?: boolean };
} | null | undefined): boolean {
  return user?.capabilities?.factoryWorker === 'approved';
}

export function isApprovedFactoryManager(user: {
  capabilities?: { factoryManager?: boolean; factoryRole?: string; factoryWorker?: string };
} | null | undefined): boolean {
  if (user?.capabilities?.factoryManager === true) return true;
  return (
    user?.capabilities?.factoryWorker === 'approved'
    && user?.capabilities?.factoryRole === 'manager'
  );
}
